<template>
  <div class="cart-holder">

    <h1>Kosár tartalma</h1>

    <div id="webshop-cart-div" class="webshop-cart-block">
      <div v-if="productData.products_count" class="table-div cart-desktop">
        <div class="table-div cart-desktop">
          <table class="table">

            <tr>
              <th>{{ t.name }}</th>
              <th class="">{{ t.quantity }}</th>
              <th class="text-right">{{ t.net_unit_price }}</th>
              <th class="text-right">{{ t.net_price }}</th>
              <th class="text-right">{{ t.vat }}</th>
              <th class="text-right">{{ t.gross_price }}</th>
            </tr>

            <tr v-for="(p, pidx) in productData.products" v-bind:key="pidx">
              <td v-html="p.name_url">{{ p.name_url }}</td>
              <td class="p-quantity">
                <div class="input-group">
                  <input type="number" min="1" v-model="p.quantity" class="form-control" :data-lineid="p.key"  @change="setQuantity(pidx,p.quantity, $event)">
                  <i class="fa fa-times cart-delete-button" :data-lineid="p.key" @click="removeProduct($event)"></i>
                </div>
              </td>
              <td class="text-right product-net-unit-span">{{ p.net_unit_price }}<br/></td>
              <td class="text-right product-net-span">{{ p.net_price }}</td>
              <td class="text-right product-tax-span">{{ p.tax_value }}</td>
              <td class="text-right product-total-span">{{ p.gross_price }}</td>
            </tr>

            <tr class="table-light">
              <td></td>
              <td></td>
              <td class="text-right"><b>{{ t.altogether }}</b></td>
              <td class="text-right total-net-span"><b>{{ productData.total.net_formatted }}</b></td>
              <td class="text-right total-tax-span"><b>{{ productData.total.tax_formatted }}</b></td>
              <td class="text-right total-total-span"><b>{{ productData.total.gross_formatted }}</b></td>
            </tr>

          </table>
        </div>
      </div>

      <div v-if="productData.products_count">
        <div class="webshop-cart-mobile">
        <div class="cart-item-data" v-for="(p, pidx) in productData.products" v-bind:key="pidx">

          <div class="row">
            <div class="col-12 product-url-mobile">
              <div class="product-image" v-html="p.product_image"></div>
              <div class="product-name" v-html="p.name_url"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.cut_sizes }}
            </div>
            <div class="col-6 text-left product-size-mobile">
              {{ p.size }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.quantity }}
            </div>
            <div class="col-6 text-left product-unit_size-mobile">
              <div class="input-group">
                <input type="number" min="1" v-model="p.quantity" class="form-control" :data-lineid="p.key"  @change="setQuantity(pidx,p.quantity, $event)">
                <i class="fa fa-times cart-delete-button" :data-lineid="p.key" @click="removeProduct($event)"></i>
              </div>
            </div>
          </div>

          <div class="row product-item-line">
            <div class="col-6 text-left product-header-mobile">
              {{ t.net_unit_price }}
            </div>
            <div class="col-6 text-left product-net-unit-mobile">
              {{ (p.net_unit_price) }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.net_price }}
            </div>
            <div class="col-6 text-left product-net-mobile">
              {{ (p.net_price) }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.vat }}
            </div>
            <div class="col-6 text-left product-tax-mobile">
              {{ (p.tax_value) }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.gross_price }}
            </div>
            <div class="col-6 text-left product-total-mobile">
              {{ (p.gross_price) }}
            </div>
          </div>

        </div>

        <div class="cart-item-total mb-5">

          <div class="row">
            <div class="col-12 product-total-header-mobile">{{ t.altogether }}</div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{ t.net_price }}
            </div>
            <div class="col-6 text-left total-net">
              <strong>{{ (productData.total.net_formatted) }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{  t.vat }}
            </div>
            <div class="col-6 text-left total-tax">
              <strong>{{ (productData.total.tax_formatted) }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{ t.gross_price }}
            </div>
            <div class="col-6 text-left total-total">
              <strong>{{ (productData.total.gross_formatted) }}</strong>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div v-if="productData.products_count < 1" class="alert alert-warning">{{ t.your_cart_is_empty }}</div>
    </div>

    <div class="webshop-step-holder">

          <div class="webshop-step-left">
            <div class="step-button">
              <a href="/termekek" class="btn btn-secondary"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back_to_webshop }}</a>
            </div>
          </div>
      <div class="step-button" v-if="productData.products_count">
        <button class="btn btn-danger" v-on:click="emptyCart">{{ t.empty_cart }}</button>
      </div>
          <div class="webshop-step-right" v-if="productData.products_count">
            <div class="step-button">
              <router-link :to="{ name: 'Customer' }" class="btn btn-secondary">
                {{ t.next }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>




    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Cart',
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      productData: "getProductData",
      orderData: "getOrderData",
      currentStep: "getCurrentStep",
    }),
  },
  data(){
    return {originalData: {}};
  },
  methods:{
    /**
     * Termék frissítése
     *
     * Megjegyzés:
     * Azért $this.productData adjuk át, mert v-model="p.quantity" lett magadva és
     * ez módosítja a $this.productData -ban megadott értéket is, ha az input változik.
     */
    updateProduct: function (){
      let $this = this;

      let formData = {
        'page'        : 'Cart',
        'method'      : 'UpdateProduct',
        'productData' : $this.productData
      };

      $this.$store.dispatch('setData', formData);
    },
    setQuantity: function (pidx, quantity, e){
      let $this = this;
      if(quantity < 1){
        $this.$store.dispatch('setProductQuantity', {index:pidx,value:1});
        quantity = 1;
      }
      let formData = {
        'page': 'Cart',
        'method': 'SetQuantity',
        'line_id': e.target.dataset.lineid,
        'quantity': quantity
      };
      $this.$store.dispatch('setData', formData);

    },
    // Kosárból törlés
    removeProduct: function (e){
      let $this = this;
      if(confirm('Biztos benne hogy törölni szeretné?')) {
        let formData = {
          'page': 'Cart',
          'method': 'RemoveProduct',
          'line_id': e.target.dataset.lineid
        };

        $this.$store.dispatch('setData', formData);
      }
    },

    // Kosár ürítése
    emptyCart: function (){
      let $this = this;

      let formData = {
        'page'        : 'Cart',
        'method'      : 'EmptyCart',
        'productData' : $this.productData
      };

      $this.$store.dispatch('setData', formData);
    },
  },
  updated() {
    /** Kosár Ár beállítás */
    const carts = document.querySelectorAll('.webshop-cart-widget');
    carts[1].setAttribute('data-webshop-cost', '0 Ft'); // Default Value

    if(this.productData.products_count)
      carts[1].setAttribute('data-webshop-cost', this.productData.total.net_formatted);

    const cartCount = document.querySelectorAll('.cart-count-span');
    cartCount[1].textContent = this.productData.products_count;
  },
  beforeCreate() {
    this.$store.commit('setCurrentStep', 'Cart');
  },
  created(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>